import { userService } from '../services';

export const fetchPendingRequests = (params) => async (dispatch) => {
  dispatch({ type: 'FETCHING_REQUESTS' });
  try {
    const response = await userService.get_pending_requests(params);
    if (response.data) {
      dispatch({ type: 'SET_REQUESTS', payload: response.data });
    }
  } catch {
    dispatch({ type: 'FETCH_REQUESTS_COMPLETE' });
  }
};
